import React, { Component } from 'react';
import NumberInput from 'material-ui-number-input';
import Slider from 'rc-slider';
import 'rc-slider/assets/index.css';

import '../styles/InputSlider.css';

export default class InputSlider extends Component {
  constructor(props) {
    super(props);
    const def = this.props.defaultValue !== undefined ?
     this.props.defaultValue :
     this.props.min;

    this.state = {
      stringValue: def.toString(),
      value: def
    };

  }

  render() {
    return (
        <div className="input-slider-wrapper">
          <div className="input-slider-row">
            <NumberInput
            name="input"
            min={this.props.min}
            max={this.props.max}
            value={this.state.stringValue}
            onChange={(e, val) => this.handleChange(val)}
            onBlur={(e, val)   => this.handleInputBlur()}
            className="input-slider-input"
            />
          </div>
          <div className="input-slider-row">
            <div className="input-slider-label">
              {this.props.min} {this.props.unit}
            </div>
            <Slider
            name="slider"
            min={this.props.min}
            max={this.props.max}
            step={this.props.step}
            value={this.state.value}
            onChange={(val) => this.handleChange(val)}
            className="input-slider"
            />
            <div className="input-slider-label">
              {this.props.max} {this.props.unit}
            </div>
          </div>
        </div>
    );
  }

  handleChange(stringValue){
    let value = this.props.min;
    stringValue = ""+stringValue;

    if (stringValue !== "") {
      value = parseFloat(stringValue);
      if (value < this.props.min) {
        value = this.props.min;
      }

      if (value > this.props.max) {
        value = this.props.max;
      }
      stringValue = ""+value;
    }

    this.setState({
      value: value,
      stringValue: stringValue
    });

    if (this.props.onChange) {
      this.props.onChange(value);
    }

  }


  handleInputBlur(){
    this.setState({
      stringValue: ""+this.state.value
    });
  }
}


// InputSlider.propTypes = {
//   min: React.PropTypes.numeric.isRequired,
//   max: React.PropTypes.numeric.isRequired,
//   step: React.PropTypes.numeric.isRequired,
//   defaultValue: React.PropTypes.numeric.isRequired,
//   unit: React.PropTypes.string.isRequired,
// };



// WEBPACK FOOTER //
// ./src/components/InputSlider.js